import { ROUTE_NAMES } from '$router/config'
import Navigate from '$router/Navigate'

const GlobalServiceUserIndexPage = () => {
  return (
    <Navigate
      to={ROUTE_NAMES.GLOBAL_SERVICE_USER_DETAIL}
      options={options => ({ ...options, replace: true })}
    />
  )
}

export default GlobalServiceUserIndexPage
